'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _viskanDekuGrid = require('viskan-deku-grid');

var _config = require('../config');

var _methods = require('../methods');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
/* eslint react/jsx-key: 0 */
var renderHeadings = function renderHeadings(props) {
	var headings = (0, _methods.getHeadings)(_config.fields, props);

	return headings.map(function (heading) {
		return (0, _magicVirtualElement2.default)(
			_viskanDekuGrid.Cell,
			{ size: heading.sizes.mobile, 'md-size': heading.sizes.tablet, 'lg-size': heading.sizes.desktop },
			(0, _magicVirtualElement2.default)(
				'div',
				{ 'class': props.styleClasses.Heading, 'data-style-attr': 'Heading', style: { textAlign: heading.align } },
				heading.value
			)
		);
	});
};

var render = function render(_ref) {
	var props = _ref.props;

	if (!props.showHeadings) {
		return (0, _magicVirtualElement2.default)('noscipt', null);
	}

	return (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['CMS-Component-SKU-Table-Header', props.styleClasses.Headings_Wrapper], 'data-style-attr': 'Headings_Wrapper' },
		(0, _magicVirtualElement2.default)(
			_viskanDekuGrid.Grid,
			null,
			renderHeadings(props)
		)
	);
};

exports.default = { render: render, name: 'CMS-Component-SKU-Table-Header' };